import React from "react";

import domikLogo from "../../content/images/logo128.png"; // Tell webpack this JS file uses this image

import { SideBarNavigationItem } from "./SideBarNavigationItem";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

export const SideBar = () => {
  const navigationElements = useSelector(
    (state: any) => state.sideNavigation.elements
  );

  return (
    <div className="sidebar-fixed position-fixed">
      <Link to="/">
        <a className="logo-wrapper waves-effect">
          <img src={domikLogo} className="img-fluid" alt="DOMIK logo" />
        </a>
      </Link>

      <div className="list-group list-group-flush">
        {navigationElements.map((element: any) => {
          return (
            <SideBarNavigationItem
              text={element.text}
              link={element.link}
              iconClassName={element.iconClassName}
              isActive={window.location.href.indexOf(element.link) >= 0}
            />
          );
        })}
      </div>
    </div>
  );
};
